import styled, { css, keyframes } from 'styled-components'

import FormLabel from '../../FormLabel'
import Icon from '../../../components/Icon'

export const Container = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.textStyles.montserratTextBase}
  color: ${({ theme }) => theme.colors.greyFields};
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
    `}
`

export const Label = styled(FormLabel)`
  margin-bottom: 1.4rem;
`

const HintMessage = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
  margin-top: 0.5rem;
  padding-inline: 0.8rem;
  text-align: left;
`
export const HelpMessage = styled(HintMessage)`
  color: ${({ theme }) => theme.colors.bismark};
`
export const ErrorMessage = styled(HintMessage)`
  color: ${({ theme }) => theme.colors.error};
`

export const StarIcon = styled(Icon)``

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }

  30% {
    transform: rotate(10deg);
  }

  70% {
    transform: rotate(-10deg);
  }
`

export const CustomStarSvgContainer = styled.div`
  display: flex;
  &:hover {
    animation: ${rotate} 0.3s ease-in-out;
  }
  padding: 0;
  margin: 0;
  font-size: 1.2rem;
`
